import { useEffect, useState } from 'react'
import './App.css'
import AppRouter from './router/AppRouter'
import { initializeAxiosToken } from './utils/session'
import { subscribeApiSubmitLoading } from './utils/api'

const App = () => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  // Initialize token from localStorage on app load
  useEffect(() => {
    initializeAxiosToken()
  }, [])

  useEffect(() => {
    const unsubscribe = subscribeApiSubmitLoading((loading) => {
      setIsSubmitting(loading)
    })

    return unsubscribe
  }, [])

  return (
    <>
      <AppRouter />
      {isSubmitting && (
        <div className="global-submit-loader-overlay" role="status" aria-live="polite" aria-label="Submitting request">
          <div className="global-submit-loader-card">
            <div className="global-submit-loader-spinner" />
            <div className="global-submit-loader-text">Please wait....</div>
          </div>
        </div>
      )}
    </>
  )
}

export default App
